<template>
  <b-modal
    id="delete-modal"
    title="Confirm Delete"
    ref="DeleteProduct"
    hide-footer
    hide-header
    size="lg"
  >
    <b-row>
      <b-col sm="1">
        <img src="@/assets/images/warning.svg" alt="warning icon" />
      </b-col>
      <b-col sm="10">
        <p class="modal-main-message">{{ deletePromptMessage }}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="9"></b-col>
      <b-col sm="3">
        <div class="action-buttons">
          <b-button
            variant="ghost"
            class="p-0 border-0 shadow-none mx-2"
            :disabled="loading"
            style="color: #ff8828;"
            @click="closeModal()">
            No
          </b-button>
          <b-button
            variant="ghost"
            class="p-0 border-0 shadow-none mx-2"
            :disabled="loading"
            style="color: #d6d6d6;"
            @click="deleteProduct()">
            Yes
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ConfirmDelete",
  props: ["status", "name"],
  computed: {
    ...mapState("estoreInventories", [
      "loading",
      "errors",
      "modal",
      "taggedProducts",
    ]),

    deletePromptMessage() {
      if (this.modal.delete_product.is_tagged > 0) {
        return "This product is currently tagged to a brand and branch. Are you sure you want to delete this?";
      } else {
        return "Are you sure you want to permanently delete this product?";
      }
    },
  },
  methods: {
    closeModal: function () {
      this.$store.commit("estoreInventories/setModal", {
        type: "delete_product",
        status: false,
        uuid: null,
        name: "",
        is_tagged: false,
      });
    },

    deleteProduct: async function () {
      let param = {
        uuid: this.modal.delete_product.uuid,
        payload: {
          keyword: "",
        },
      };

      await this.$store
        .dispatch("estoreInventories/deleteProduct", param)
        .then(() => {
          if (this.errors == null) {
            this.$store.commit("estoreInventories/setModal", {
              type: "delete_product",
              status: false,
              uuid: null,
              name: "",
              is_tagged: false,
            });
            this.$store.dispatch("estoreInventories/getProducts", {
              page: 1,
              payload: {
                filters: {
                  paired_key: "all",
                  keyword: "",
                  column: "all",
                },
              },
            });
          }
        });
    },
  },
  watch: {
    status: function (status) {
      if (status == true) {
        this.$refs.DeleteProduct.show();
      } else {
        this.$refs.DeleteProduct.hide();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.action-buttons {
  cursor: pointer;
}
</style>